module.exports = __webpack_public_path__ + "img/sxt.3bdb9ff0.png";